angular.module("correspondences_types")

    .controller("CorrespondencesTypesListCtrl", ['LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$filter', '$state', function (LoginService, $rootScope, $scope, Restangular, gridService, modalService,  $filter,  $state) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("CORRESPONDENCE_TYPE_WRITE");

        $rootScope.title = $filter('translate')('correspondences_types.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('correspondences_types.title') }
        ];

        $scope.selectEntityTypes = [{ id: null, name: $filter("translate")('entity_types.all') }, { id: 'events', name: $filter("translate")('entity_types.events') }, { id: 'correspondence', name: $filter("translate")('entity_types.correspondence') }];;
        $scope.search = { entity_type: null };
        $scope.gridOptionsCorrespondencesTypes = {
            pdfTitle: $filter('translate')('correspondences_types.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,             
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'code', displayName: $filter('translate')('correspondences_types.code'), enableFiltering: false, enableHiding: true },
                { name: 'name', displayName: $filter('translate')('correspondences_types.name'), enableFiltering: true, enableHiding: false },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('correspondences_types.button_edit'), action: 'ui-sref="correspondences_types.edit({id:row.entity.id})"', cssClass: "btn btn-xs btn-default btn-outline btn-custom-laptop", cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('correspondences_types.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssClass: "btn btn-xs btn-default btn-outline btn-custom-laptop", cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                options.entity_type = $scope.search.entity_type;
                return Restangular.all('CorrespondencesTypes').getList(options);
            }
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("correspondences_types.edit", { id: rowEntity.id });
        }

        $scope.loadData = function () {
            $scope.gridOptionsCorrespondencesTypes.loadData(false);
        }

        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('correspondences_types.button_delete'),
                message: $filter('translate')('correspondences_types.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('CorrespondencesTypes', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('correspondences_types.deleted_success'));
                        $scope.gridOptionsCorrespondencesTypes.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };
        
    }])

;